import React, { memo } from 'react';
export const ModulesSection = () => {
  const items = [{
    num: '1',
    icon: '🧠',
    title: 'The Core Vitality 360 System',
    desc: 'Everyday care guidance for common situations, including Alzheimer’s, Parkinson’s and hypertension — written in plain language for families, not clinicians.'
  }, {
    num: '2',
    icon: '📝',
    title: '150+ Printable Brain Stimulation Activity Sheets',
    desc: 'Large-print cognitive stimulation activities for memory, language and logic, ready to print whenever you need them.'
  }, {
    num: '3',
    icon: '🛡️',
    title: 'The Fearless Mobility Protocol',
    desc: 'Gentle movement, coordination and balance routines designed to bring more activity into everyday life at home.'
  }, {
    num: '4',
    icon: '📋',
    title: 'Health & Medication Tracking Logs',
    desc: 'Daily and weekly tracking pages that keep routines, observations and appointment notes organized in one place.'
  }, {
    num: '5',
    icon: '❤️',
    title: 'The Resilient Caregiver Guide',
    desc: 'Caregiver organization tools and simple ways to protect your own time, energy and peace of mind.'
  }];
  return <section id="modulos" className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-127" data-mp="18wj61wg1vuk0">
      <div className="max-w-5xl mx-auto w-[92%] md:w-full" data-id="element-128" data-mp="1duktsuof8i1t">
        <div className="text-center mb-10 md:mb-12" data-id="element-129" data-mp="104haocku94gl">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-130" data-mp="102o40xa86k8l">
            See What’s Actually Inside
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-131" data-mp="q7coicqzt8zs">
            These aren’t vague ideas or activities you have to create yourself.
            Vitality 360™ includes ready-to-use resources you can open, print
            and use at home — cognitive activities, gentle movement, tracking
            pages, caregiver tools, nutrition and connection ideas, and
            home-safety resources. Download it once and use it whenever you need
            it.
          </p>
        </div>

        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16" data-id="element-132" data-mp="2j245z54jf8j1">
          <h3 className="text-xl md:text-2xl font-display font-bold mb-3" data-id="element-133" data-mp="2e5docdd344vi">
            Take a Quick Look Inside Vitality 360™
          </h3>
          <p className="text-familia-gray text-[14px] md:text-base mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-134" data-mp="2936afi8p2eqj">
            See the actual printable materials, activity pages, caregiver tools and trackers included in the kit — so you know exactly what you're getting before you buy.
          </p>
          <div className="relative rounded-2xl overflow-hidden border border-familia-cyan/25 shadow-[0_8px_30px_-8px_rgba(0,0,0,0.3)] bg-familia-bg" data-id="element-135" data-mp="2wwwrqlb0tky2">
            <video className="w-full h-auto block" controls autoPlay muted playsInline loop preload="metadata" data-id="element-136" data-mp="1lfwzfpoob641">
              <source src="https://cdn.magicpatterns.com/uploads/tSAF3CqRqaEBPUcgeaDXxK/vitality360-preview.webm" type="video/webm" data-id="element-137" data-mp="3t2ztio0bo9b2" />
              Your browser does not support the video tag.
            </video>
          </div>
          <p className="text-[11px] sm:text-xs text-familia-gray/80 mt-4" data-id="element-138" data-mp="5umfbo1m1ijy">
            Real pages from the Vitality 360™ digital kit. What you see is what you'll receive.
          </p>
        </div>

        <div className="space-y-4" data-id="element-139" data-mp="foms8c34vs38">
          {items.map((item, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-6 md:p-8 rounded-2xl flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 text-center sm:text-left" data-id="element-140" data-mp="kk226sy0t3ud" data-mpi={i}>
              <div className="bg-familia-bg w-16 h-16 rounded-full flex items-center justify-center text-3xl shrink-0 border border-white/10" data-id="element-141" data-mp="2qetke0wjle06">
                {item.icon}
              </div>
              <div data-id="element-142" data-mp="203ht9l2y2csy">
                <p className="text-familia-cyan font-mono font-bold text-xs sm:text-sm mb-1" data-id="element-143" data-mp="202ykatv9uyr2">
                  ITEM {item.num}
                </p>
                <h3 className="text-lg md:text-xl font-display font-bold mb-2" data-id="element-144" data-mp="1v458r6zjphtj">
                  {item.title}
                </h3>
                <p className="text-familia-gray text-[14px] md:text-base" data-id="element-145" data-mp="252kxj3b3oezv">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};